export const RACE_PACKAGE_TEXT_SUFFIX =
  '제품 사진을 #해시태그와 함께 인스타그램에 올려주세요.';
